import { FormDetailsType } from '@app-src/types'
import lookupAccountId from '@app-src/data/accounts/lookupAccountId'

const REQUIRED_FORM_DETAIL_FIELDS = [
  'accountName',
  'categoryName',
  'formName',
  'product'
]

/**
 * validateFormDetailParameters
 * @description Validates that form API calls have been made with the required parameters set in formDetails.
 *   An exception will be thrown if something is missing
 * @param {Object} formDetails - the form details which came in from an API call
 */
export function validateFormDetailParameters(formDetails: FormDetailsType) {
  REQUIRED_FORM_DETAIL_FIELDS.forEach(requiredField => {
    if (!Boolean((formDetails as Record<string, unknown>)[requiredField])) {
      throw new Error(
        `you must provide a value for ${requiredField} when calling this API`
      )
    }
  })
}

/**
 * ensureFormDetailsAccountId
 * @description Ensures that the formDetails contain a guid-based accountId, and
 *   fetches one from the account ID lookup endpoint if not availab le
 * @param {Object} formDetails - the form details which came in from an API call
 * @return {Object} - formDetails with a filled in accountId
 */
export async function ensureFormDetailsAccountId(
  formDetails: FormDetailsType
): Promise<FormDetailsType> {
  const { accountId, dealerId } = formDetails
  if (!accountId) {
    if (dealerId) {
      formDetails.accountId = (await lookupAccountId(dealerId)) as string
      if (!formDetails.accountId) {
        throw new Error(`could not resolve dealerId ${dealerId}`)
      }
    } else {
      throw new Error(`you must provide accountId or dealerId`)
    }
  }
  return formDetails
}
